import { useState, useRef } from 'react';

const S = (p) => ({ viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round', strokeLinejoin: 'round', ...p });

const Icons = {
  consolidate: (c) => (<svg {...S({ className: c })}><path d="M3 7l9-4 9 4-9 4-9-4z" /><path d="M3 7v10l9 4 9-4V7" /><path d="M12 11v10" /></svg>),
  inspect: (c) => (<svg {...S({ className: c })}><circle cx="11" cy="11" r="6" /><path d="M20 20l-3.6-3.6" /><path d="M8.6 11l1.7 1.7L14 9.5" /></svg>),
  docs: (c) => (<svg {...S({ className: c })}><path d="M6 2.5h7l5 5V21.5H6z" /><path d="M13 2.5v5h5" /><path d="M9 13h6M9 16.5h6" /></svg>),
  container: (c) => (<svg {...S({ className: c })}><rect x="3" y="7" width="18" height="11" rx="1" /><path d="M7.5 7v11M12 7v11M16.5 7v11" /></svg>),
  truck: (c) => (<svg {...S({ className: c })}><path d="M2.5 6.5h11v9h-11z" /><path d="M13.5 9.5h4l3.5 3.5v2.5h-7.5z" /><circle cx="7" cy="18" r="1.7" /><circle cx="17.5" cy="18" r="1.7" /></svg>),
  finance: (c) => (<svg {...S({ className: c })}><rect x="2.5" y="5" width="19" height="14" rx="2" /><path d="M2.5 9.5h19M6 15h4" /></svg>),
  people: (c) => (<svg {...S({ className: c })}><circle cx="9" cy="8" r="3" /><path d="M3.5 19a5.5 5.5 0 0 1 11 0" /><path d="M16 6.6a3 3 0 0 1 0 5.8" /><path d="M17.6 19a5.5 5.5 0 0 0-2.8-4.8" /></svg>),
  pin: (c) => (<svg {...S({ className: c })}><path d="M12 21s7-6.4 7-11a7 7 0 1 0-14 0c0 4.6 7 11 7 11z" /><circle cx="12" cy="10" r="2.4" /></svg>),
  user: (c) => (<svg {...S({ className: c })}><circle cx="12" cy="8" r="3.4" /><path d="M5.5 20a6.5 6.5 0 0 1 13 0" /></svg>),
  chat: (c) => (<svg {...S({ className: c })}><path d="M4 5h16v11H9l-4 3.5V16H4z" /></svg>),
  mail: (c) => (<svg {...S({ className: c })}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3.5 7.5l8.5 6 8.5-6" /></svg>),
};

const SERVICES = [
  { icon: 'consolidate', title: 'Goods Consolidation', desc: 'Combine products from multiple suppliers across Chinese provinces into single, efficient shipments.' },
  { icon: 'inspect', title: 'Goods Inspection', desc: 'On-the-ground inspection in Chinese factories and warehouses before anything loads.' },
  { icon: 'docs', title: 'Export Documentation', desc: 'Full handling of export documents, customs invoices, and packing lists.' },
  { icon: 'container', title: 'Container Optimization', desc: 'Maximise container space utilisation to bring shipping costs down.' },
  { icon: 'truck', title: 'End-to-End Logistics', desc: 'Complete supply-chain execution from dispatch to final delivery — a Dubai specialty.' },
  { icon: 'finance', title: 'Financial Services', desc: 'Flexible payment terms for established clients.' },
  { icon: 'people', title: 'Buyer Assistance', desc: 'Market visits, translation, supplier negotiation, and deposit handling.' },
];

const SHOWCASE = ['IMG_8887', 'IMG_6341', 'IMG_9305', 'IMG_8895', 'IMG_6356', 'IMG_9322', 'IMG_8407', 'IMG_6319', 'IMG_9703', 'IMG_8427', 'IMG_6230', 'IMG_8976', 'IMG_8408', 'IMG_8381', 'IMG_9899'];

const OFFICES = [
  { city: 'Hong Kong', company: 'Sinocom Global Limited', address: 'RM A 9/F Silvercorp Intl Tower, 707-713 Nathan Rd, Mongkok, Kowloon', contactName: 'Pankaj Ahuja', phone: '+86 156 2722 3593', whatsapp: '8615627223593', color: '#D7A94A' },
  { city: 'Yiwu', company: 'Yiwu Fusheng Trading Firm', address: 'Room 601, 6F, Building 6, Duhui Wenlan, Yiwu City, Zhejiang Province', addressCn: '浙江省义乌市都会文澜6栋6楼601室', contactName: 'Gulshan Gordhadas Khatri', phone: '+86 150 5791 0421', whatsapp: '8615057910421', color: '#8E86C9' },
  { city: 'Mumbai', company: 'Jai Shivam Creation', address: '87-89 Trinity House, Ground Floor, S S Gaikwad Marg, Dhobi Talao, Mumbai 400 002', contactName: 'Kishore Bhagwandas Dodeja', phone: '+91 78208 54392', whatsapp: '917820854392', color: '#D98AAE' },
  { city: 'Bangkok', company: 'Salina Intertrade Co., Ltd.', address: 'House No. 28, Sukhumvit Soi 29, Khlong Tan Neau, Vadhana, Bangkok 10110, Thailand', contactName: 'Pankaj Ahuja', phone: '+66 95 558 1160', whatsapp: '66955581160', color: '#E0936B' },
  { city: 'Dubai', company: 'Sinocom Global Trading LLC', address: 'Shams Business Center, Sharjah Media City Free Zone, Al Messaned, Sharjah, UAE', contactName: 'Sanjay Chawla', phone: '+971 50 186 6343', whatsapp: '971501866343', email: 'sinocom.ae@outlook.com', color: '#5BC0BE' },
];

// Production uses the same-origin nginx API proxy. Development keeps the
// existing hosted endpoint so CRA can run without a local reverse proxy.
const CONTACT_API = process.env.NODE_ENV === 'production'
  ? '/api/contact/submit'
  : 'https://api.supplierform.com/contact/submit';
const officeId = (city) => `office-${city.replace(/\s+/g, '-')}`;

function Sections() {
  const [highlight, setHighlight] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', phone: '', location: '', enquiry: '', company: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const highlightTimer = useRef(null);

  // footer region click → scroll to that office card and glow it briefly
  const goToOffice = (city) => {
    setHighlight(city);
    document.getElementById(officeId(city))?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    clearTimeout(highlightTimer.current);
    highlightTimer.current = setTimeout(() => setHighlight(null), 2600);
  };

  const goToForm = () => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  const setField = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submitEnquiry = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch(CONTACT_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ source: 'sinocom-global', ...form }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setStatus('sent');
      setForm({ name: '', email: '', phone: '', location: '', enquiry: '', company: '' });
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <>
      {/* About */}
      <section id="about" className="section section--a">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">01 — Who we are</span>
            <h2 className="h2">A trading house, <em>since 1984.</em></h2>
          </div>
          <div className="about-grid">
            <div className="about-copy lead">
              <p>
                Sinocom started in 1984 with a salesman and one lesson learned on the road: you don't move
                what you want to sell — you move what the other side actually needs. Four decades on, that's
                still the whole job, and it's still run day to day by the man who started it.
              </p>
              <p>
                The business grew out of a warehouse in Thailand and followed the goods to China as it rose —
                <strong> Guangzhou</strong> first, then <strong>Foshan</strong>, <strong>Shishi</strong>, and
                <strong> Yiwu</strong>. Those supplier relationships still run our shipments today, out of our
                <strong> Hong Kong</strong> headquarters and hubs in <strong>Yiwu, Bangkok, Mumbai, and Dubai</strong>,
                into markets across Africa — the core of the business — and the Middle East.
              </p>
              <p>
                The trade keeps changing. It used to be full containers and simple instructions; now it's
                consolidation — many suppliers, many small orders, packed into one container with one clean set
                of papers. Getting that right is what we do.
              </p>
            </div>
            <div className="stats">
              <div className="stat"><div className="stat-num">1984</div><div className="stat-label">Established</div></div>
              <div className="stat"><div className="stat-num">23</div><div className="stat-label">Countries served</div></div>
              <div className="stat"><div className="stat-num">4</div><div className="stat-label">Continents</div></div>
              <div className="stat"><div className="stat-num">5</div><div className="stat-label">Global offices</div></div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services" className="section section--b">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">02 — What we do</span>
            <h2 className="h2">Our services</h2>
          </div>
          <div className="cards">
            {SERVICES.map((s) => (
              <div className="card" key={s.title}>
                {Icons[s.icon]('card-icon')}
                <h3 className="card-title">{s.title}</h3>
                <p className="card-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Showcase */}
      <section id="showcase" className="section section--a">
        <div className="container">
          <div className="section-head center">
            <span className="eyebrow">03 — Proof</span>
            <h2 className="h2">What we actually ship</h2>
          </div>
          <div className="showcase-grid">
            {SHOWCASE.map((img, i) => (
              <div className="shot" key={img}>
                <img src={`/showcase/${img}.jpg`} alt={`Container shipment ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
          <div className="center-row">
            <a className="btn btn-ghost" href="/gallery.html">See the full gallery →</a>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="section section--a">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">04 — Find us</span>
            <h2 className="h2">Contact our offices</h2>
          </div>
          <div className="contact-grid">
            {OFFICES.map((o) => (
              <div className={`office${highlight === o.city ? ' is-highlight' : ''}`} id={officeId(o.city)} key={o.city}>
                <div className="office-top">
                  <span className="office-dot" style={{ background: o.color }} />
                  <span className="office-city">{o.city}</span>
                </div>
                <p className="office-co">{o.company}</p>
                <div className="office-row">{Icons.pin()}<span>{o.address}{o.addressCn ? <><br /><span className="cn">{o.addressCn}</span></> : null}</span></div>
                {o.contactName && (
                  <div className="office-row">{Icons.user()}<span>{o.contactName}</span></div>
                )}
                {o.whatsapp && (
                  <div className="office-row">{Icons.chat()}<a className="wa" href={`https://wa.me/${o.whatsapp}`} target="_blank" rel="noopener noreferrer">{o.phone}</a></div>
                )}
                {o.email && (
                  <div className="office-row">{Icons.mail()}<a href={`mailto:${o.email}`}>{o.email}</a></div>
                )}
              </div>
            ))}
          </div>

          <div className="contact-cta">
            <h3>Ready to streamline your trade?</h3>
            <p>Five time zones, five teams, one network. <button type="button" className="link-inline" onClick={goToForm}>Message</button> the office nearest your lane and we'll take it from there.</p>
          </div>

          <form id="contact-form" className="contact-form" onSubmit={submitEnquiry}>
            <h3>Send us an enquiry</h3>
            <div className="form-grid">
              <label className="field">
                <span>Name</span>
                <input type="text" value={form.name} onChange={setField('name')} required placeholder="Your name" />
              </label>
              <label className="field">
                <span>Email</span>
                <input type="email" value={form.email} onChange={setField('email')} placeholder="you@company.com" />
              </label>
              <label className="field">
                <span>Phone</span>
                <input type="tel" value={form.phone} onChange={setField('phone')} placeholder="+__ ___ ___ ____" />
              </label>
              <label className="field">
                <span>Location</span>
                <input type="text" value={form.location} onChange={setField('location')} placeholder="City / country" />
              </label>
            </div>
            <label className="field field--full">
              <span>Enquiry</span>
              <textarea value={form.enquiry} onChange={setField('enquiry')} rows={4} required placeholder="What are you looking to ship, and from where?" />
            </label>
            {/* honeypot — hidden from users, catches bots */}
            <input className="hp-field" type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" value={form.company} onChange={setField('company')} />
            <div className="form-foot">
              <button type="submit" className="btn btn-primary" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending…' : 'Send enquiry'}
              </button>
              {status === 'sent' && <span className="form-note form-note--ok">Thanks — we've got your enquiry and will be in touch.</span>}
              {status === 'error' && <span className="form-note form-note--err">Couldn't send just now — please WhatsApp us or try again.</span>}
            </div>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="site-footer">
        <div className="footer-inner">
          <span className="footer-brand">Sinocom Global</span>
          <div className="footer-regions">
            {OFFICES.map((o, i) => (
              <span key={o.city}>
                <button type="button" className="footer-region" onClick={() => goToOffice(o.city)}>{o.city}</button>
                {i < OFFICES.length - 1 ? <span className="footer-sep"> · </span> : null}
              </span>
            ))}
          </div>
          <span className="footer-meta">© 1984–2026 · International trading</span>
        </div>
      </footer>
    </>
  );
}

export default Sections;
